// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"19351":"c1f7de0082641d15","27780":"3fd02e54bc0cff15","48963":"20a3a83f105c5289","52126":"71a4e55f9be3ebb9","53348":"92bac23575083db1"}[chunkId] + ".js";
};